import React from 'react'
import styled from 'styled-components'
import { utils } from '../styles'
import TweetEmbed from 'react-tweet-embed'
import shuffle from 'array-shuffle'

const Outer = styled.div`
  ${utils.container}
  iframe,twitterwidget {
    margin: 1rem auto;
  }
`

const tweets = [
  "814703793677824001",
  "793263521291128832",
  "816260866492473344",
  "816513763306156037",
  "809460974360985600",
  "786333530787684352",
  "783683766782926850",
  "781093055264722944",
  "779033692794564608",
  "778771802201829376",
  "773007125748473857",
  "772905328803450882",
  "770683266135392256",
  "770402345150656512",
  "767744047687401472",
  "767720021804126208",
]

const Testimonials = () => (
  <Outer>{
    shuffle(tweets).slice(0,4).map(t => (
      <TweetEmbed key={t}
                  id={t}
                  options={{ conversation: 'none', cards: 'hidden' }}/>
    ))
  }
  </Outer>
)

export default Testimonials



/** WEBPACK FOOTER **
 ** ./src/components/Testimonials.js
 **/